import React from 'react';
import toast from 'react-hot-toast';

const MensajeAdvertencia = (Titulo, Mensaje, TipoMensaje, TextoBoton) => {
    return new Promise((resolve) => {
        toast((t) => (
            <div style={{ background: '#fff', padding: '15px', borderRadius: '8px' }}>
                {Titulo && <h4>{Titulo}</h4>}
                <p>{Mensaje}</p>
                <div className="d-flex justify-content-end mt-3">
                    <button 
                        className="btn btn-primary" 
                        onClick={() => {
                            toast.dismiss(t.id);
                            resolve(true);
                        }}
                    >
                        {TextoBoton || 'Ok'}
                    </button>
                </div>
            </div>
        ), { 
            duration: Infinity,
            // Map the type if needed, but since it's a custom toast, we just show it.
        });
    });
}

export default MensajeAdvertencia;